











































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'

@Component
export default class Navigation extends Vue {
  get menu() {
    return vxm.core.openMenu
  }
  openMenu(b: boolean) {
    vxm.core.setOpenMenu(b)
  }
}
